




import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, URL } from '../../variables';
import { maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdReply } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';



class EditarCategoria extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            path: '/disciplinas',
            loading_screen: true,
            name: '',

            escolaridades: [
                'Ensino Fundamental',
                'Ensino Médio',
            ],
            escolaridade:'',
            disciplina:'',

            loading_save: false,
            msgErro: '',
            loading_image: false,

        };


    }


    get_categoria(id) {

        if (this.state.loading_screen == false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/faculdade/get_categoria/${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ redirect: true });

                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                }
                else {
                    // this.props.mudarUser(resp.user);
                    let esc='';
                    let disc='';

                    if(resp.categoria.id_externo){
                        let ens =resp.categoria.id_externo.split(' - ')[1];
                        esc=ens=='M'?'Ensino Médio':'Ensino Fundamental';

                        disc=resp.categoria.id_externo.split(' - ')[0];
                    }
                    this.setState({
                        loading_screen: false,
                        name: resp.categoria.name,
                        escolaridade:esc,
                        disciplina:disc
                    });
                    // if (resp.processo != null) {


                }




            } catch (err) {
                this.setState({ redirect: true });
                console.log(err);


            }

        })
            .catch((err) => {
                this.setState({ redirect: true });

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }



    salvar(e) {
        e.preventDefault();
        if(!this.state.escolaridade || !this.state.disciplina){
            return;
        }

        this.setState({ loading_save: true, msgErro: '' });
        let form = new FormData();
        let disci = this.state.disciplina+' - '+(this.state.escolaridade=='Ensino Fundamental'?'F':'M')
        form.append('name', this.state.name);
        form.append('categoria_id', this.props.match.params.id);
        form.append('id_externo',disci);


        fetch(`${URL}api/faculdade/update_categoria`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
            },
            body: form
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    window.scrollTo(500, 0);

                    this.setState({ loading_save: false, msgErro: erro });
                }
                else {

                    this.setState({ loading_save: false, redirect: true });

                }




            } catch (err) {
                console.log(err);
                this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor' });

            }

        })
            .catch((err) => {
                console.log(err);
                this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?' });
            });
    }


    componentDidMount() {
        this.get_categoria(this.props.match.params.id);
    }





    change_tipo(event) {
        this.setState({ tipo: event.target.value });
    }


    render() {
        return (
            <div className="row">
                {this.state.redirect == true && <Redirect to={this.state.path} />}

                <div className="col-12">
                    <div className="card">
                        <div className="card-body" id="card">


                            <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>Editar Disciplina</h4>
                            <p style={{ fontSize: '1rem', color: 'black' }}>Edite uma disciplina do seu sistema</p>
                            <br />

                            {/* <hr /> */}
                            {this.state.loading_screen == false && <div>
                                {this.state.msgErro != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
                                    <div className="alert alert-danger alert-dismissible fade show mb-0 w-100" role="alert">
                                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => this.setState({ msgErro: '' })}></button>


                                        <p style={{ marginBottom: 0 }}>{this.state.msgErro}</p>

                                    </div>
                                    <br />

                                </div>}

                                <Form onSubmit={(e) => this.salvar(e)} style={{ position: "relative" }}>
                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>Nome <Attention /></Form.Label>
                                            <Input
                                                placeholder="Nome da categoria"
                                                value={this.state.name}
                                                onChange={(e) => this.setState({ name: e.target.value })}
                                                required
                                            // title="Coloque o nome completo do usuário"
                                            />
                                        </div>
                                    </InputGroup>

                                    <InputGroup>
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>Nível de Escolaridade <Attention /></Form.Label>
                                            <select className="form-select " onChange={(e) => {

                                                this.setState({ escolaridade: e.target.value, disciplina: '' })
                                            }} required value={this.state.escolaridade}>
                                                <option
                                                    value={''}
                                                >{'Selecione um nível de escolaridade'}</option>

                                                {this.state.escolaridades.map((item, id) => (
                                                    <option
                                                        key={id}
                                                        value={item}
                                                    >{item}</option>
                                                ))
                                                }
                                                {/* <option
                                                                                                                            value={'dissertativa'}
                                                                                                                        >{'Questão dissertativa'}</option> */}
                                            </select>
                                        </div>
                                    </InputGroup>


                                    <InputGroup>
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>Disciplina <Attention /></Form.Label>
                                            <select className="form-select " onChange={(e) => {

                                                this.setState({ disciplina: e.target.value })
                                            }} required value={this.state.disciplina}>
                                                <option
                                                    value={''}
                                                >{'Selecione a disciplina da inscrição'}</option>

                                                {this.state.escolaridade == 'Ensino Fundamental' && <>
                                                    <option
                                                        value={'Linguagens'}
                                                    >{'Linguagens'}</option>

                                                    <option
                                                        value={'Matemática'}
                                                    >{'Matemática'}</option>

                                                    <option
                                                        value={'Ciências Humanas'}
                                                    >{'Ciências Humanas'}</option>

                                                    <option
                                                        value={'Ciências Naturais'}
                                                    >{'Ciências Naturais'}</option>
                                                </>}



                                                {this.state.escolaridade == 'Ensino Médio' && <>
                                                    <option
                                                        value={'Linguagens e suas Tecnologias'}
                                                    >{'Linguagens e suas Tecnologias'}</option>

                                                    <option
                                                        value={'Matemática e suas Tecnologias'}
                                                    >{'Matemática e suas Tecnologias'}</option>

                                                    <option
                                                        value={'Ciências Humanas e Sociais Aplicadas'}
                                                    >{'Ciências Humanas e Sociais Aplicadas'}</option>

                                                    <option
                                                        value={'Ciências da Natureza e suas Tecnologias'}
                                                    >{'Ciências da Natureza e suas Tecnologias'}</option>
                                                </>}

                                                {/* <option
                                                                                                                            value={'dissertativa'}
                                                                                                                        >{'Questão dissertativa'}</option> */}
                                            </select>
                                        </div>
                                    </InputGroup>


                                    {this.state.loading_save == false && <div className="w100 inline-flex jcsb margin-top-1">
                                        {/* <Link to={`/accounts/list`}>
                                    <Button variant="secondary"><RiArrowGoBackLine/> Voltar</Button>
                                </Link> */}
                                        <DefaultButton
                                            bg="secondary"
                                            text="Voltar"
                                            icon={<RiArrowGoBackLine />}
                                            to="/disciplinas"
                                        />
                                        {/* <Button variant="success" type="submit" disabled={this.loading}>
                                    {this.state.loading ? <Spinner /> : ""}
                                    Registrar usuário
                                </Button> */}
                                        <DefaultButton
                                            type="submit"
                                            bg="confirm"
                                            text="Salvar disciplina"
                                            disabled={this.state.loading_image == true}
                                            loadingtext="Salvando disciplina"
                                            loading={this.state.loading_save}
                                        />
                                    </div>}

                                    {this.state.loading_save == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center margin-top-1" >
                                        <div className="spinner-border text-primary" role="status"  >
                                        </div>
                                    </div></div>}
                                </Form>

                            </div>}

                            {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                                <div className="spinner-border text-primary" role="status"  >
                                </div>
                            </div></div>}


                        </div>

                    </div>
                </div>
            </div>
        );
    }


}
const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
    }
);

export default connect(mapsStateToProps, { logout })(EditarCategoria);


